import * as React from "react";

import { LogPanelContext } from "./LogPanelContext";

export const useLogPanelContext = () => {
  return React.useContext(LogPanelContext);
};
